import { render, staticRenderFns } from "./MoveCategoryAttachmentsDialog.vue?vue&type=template&id=eccf810a&"
import script from "./MoveCategoryAttachmentsDialog.vue?vue&type=script&lang=js&"
export * from "./MoveCategoryAttachmentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports